import { useMutation } from '@tanstack/react-query';
import { bffValidateOtp } from '../api/client';

export const useValidateOTP = () => {
    const { mutateAsync: validateOTP } = useMutation({
        mutationFn: ({ otp, refId }: { otp: string, refId: string }) => bffValidateOtp({
            otp,
            refId
        }),
    });
    return validateOTP;
}